export enum ReceiptAttachmentType {
  Pdf = 'PDF',
  Png = 'PNG',
  None = 'NONE',
}